import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

import { urlFor, client } from "../client";

function Skills() {
    const [skills, setSkills] = useState([]);

    useEffect(() => {
        const query = '*[_type == "skills"]';

        client.fetch(query).then((skills) => setSkills(skills));
    }, []);


    return (
        <div id="skills" className="h-full !pt-12">
            <motion.div
                whileInView={{ y: [50, 0], opacity: [0, 1] }}
                transition={{ duration: 1, ease: "easeInOut" }}
                className="p-3 md:p-10 w-full text-center">
                <center>
                    <div className="w-fit font-mono font-extrabold text-transparent text-4xl md:text-5xl bg-clip-text bg-gradient-to-r from-[#00c3ff] to-[#ffff1c]">
                        Skills
                    </div>
                    <br />
                    <div className="flex flex-wrap justify-center">
                        {skills.map((skill, index) => (
                            <div className="m-3 md:m-10" key={`div-${index}`}>
                                <div
                                    className="w-16 h-16 xl:w-24 xl:h-24 mb-2 rounded-full bg_blur flex justify-center items-center"
                                    key={`circle-${index}`}>
                                    <img
                                        src={urlFor(skill.icon).url()}
                                        alt="circle"
                                        className="block w-2/3 h-2/3 object-contain"
                                    />
                                </div>

                                <div key={`icon-name-${index}`}>
                                    {skill.name}
                                </div>
                            </div>
                        ))}
                    </div>
                    {/* <div className="flex flex-wrap justify-center">
                        {[
                            ReactPng,
                            PythonPng,
                            JsPng,
                            JavaPng,
                            TailwindPng,
                            SklearnPng,
                            TensorflowSvg,
                        ].map((circle, index, array) => (
                            <div className="m-3 md:m-10" key={`div-${index}`}>
                                <div
                                    className="w-16 h-16 xl:w-24 xl:h-24 mb-2 rounded-full bg_blur flex justify-center items-center"
                                    key={`circle-${index}`}>
                                    <img
                                        src={circle}
                                        alt="circle"
                                        className="block w-2/3 h-2/3 object-contain"
                                    />
                                </div>

                                <div key={`icon-name-${index}`}>
                                    {iconlist[index]}
                                </div>
                            </div>
                        ))}
                    </div> */}
                </center>
            </motion.div>
        </div>
    );
}

export default Skills;
